/* Auto-generated wrapper around assets/vsf-taxonomy.json (v2.0.1, 2026-05-21).
 * Single source of truth: assets/vsf-taxonomy.json.
 * Do not hand-edit this file — it is regenerated whenever taxonomy.json changes.
 */
window.VSF_TAXONOMY = {
  "version": "2.0.1",
  "updated": "2026-05-21",
  "source": "_dev/docs/Vyvata_Subcategory_Rubric_v2.docx",
  "note": "Canonical 5-category x subcategory taxonomy. Every consumer of category/subcategory data (engine, Liquid, triage, classifier) reads from this file. Do not hard-code subcategory names elsewhere. Regenerate from the rubric .docx via workstream 01 when the rubric changes.",
  "classification_rules": [
    "Supplements are classified by primary health goal / use case. Products serving multiple goals are classified by their primary marketed function.",
    "Sleep supplements & nutraceuticals (melatonin, magnesium for sleep, etc.) are classified under Sleep Optimization, not Supplements.",
    "Recovery nutrition & protein supplements (whey, BCAAs, creatine, collagen for recovery) are classified under Supplements — specifically Subcategory 2: Protein & Amino Acids.",
    "The Supplements vertical expands to 15 subcategories (vs. 10 for other verticals) to reflect the breadth of the market and avoid material gaps in product coverage.",
    "Subcategory ranks for Supplements reflect relative market size as of 2025–2026 and should be reviewed annually given the rapid growth of emerging segments such as Longevity & Cellular Health."
  ],
  "categories": [
    {
      "key": "supplements",
      "rank": 1,
      "name": "Supplements",
      "subcategory_count": 15,
      "subcategories": [
        {
          "key": "vitamins_micronutrients",
          "rank": 1,
          "name": "Vitamins & foundational micronutrients",
          "description": "The single largest supplement segment (~30-33% of global market). Daily multivitamins, individual vitamins (D, C, B-complex, K2), and essential mineral formulations addressing baseline nutritional gaps across all demographics.",
          "example_brands": [
            "Garden of Life",
            "Ritual",
            "Thorne",
            "Nature Made",
            "Pure Encapsulations",
            "Athletic Greens (AG1)"
          ]
        },
        {
          "key": "protein_amino_acids",
          "rank": 2,
          "name": "Protein & amino acids",
          "description": "Whey, casein, plant-based, and collagen protein powders plus isolated amino acids (BCAAs, EAAs, creatine, glutamine). Primary subcategory for active consumers. Classified here; recovery nutrition resides in this subcategory per Vyvata taxonomy.",
          "example_brands": [
            "Optimum Nutrition",
            "Momentous",
            "Gainful",
            "Orgain",
            "RXBAR",
            "Vital Proteins"
          ]
        },
        {
          "key": "gut_digestive",
          "rank": 3,
          "name": "Gut health & digestive support",
          "description": "Probiotics, prebiotics, postbiotics, digestive enzymes, fiber supplements, and gut-lining support compounds (L-glutamine, zinc carnosine). One of the fastest-growing segments at ~9-10% CAGR.",
          "example_brands": [
            "Seed Daily Synbiotic",
            "Garden of Life RAW Probiotics",
            "Culturelle",
            "Zoe",
            "Pendulum"
          ]
        },
        {
          "key": "immune_antioxidants",
          "rank": 4,
          "name": "Immune health & antioxidants",
          "description": "Vitamin C, zinc, elderberry, echinacea, beta-glucans, quercetin, NAC, and broad-spectrum antioxidant blends. The immunity segment led the US market by application in 2024 and remains a top driver of repeat purchase.",
          "example_brands": [
            "Airborne",
            "Emergen-C",
            "Sambucol",
            "Thorne",
            "Life Extension",
            "NOW Foods"
          ]
        },
        {
          "key": "cognitive_nootropics",
          "rank": 5,
          "name": "Cognitive health & nootropics",
          "description": "Memory, focus, mental clarity, and neuroprotection supplements including lion's mane, bacopa, rhodiola, alpha-GPC, phosphatidylserine, and racetam-adjacent compounds. Market projected to reach $8.3B by 2030 at 11.8% CAGR.",
          "example_brands": [
            "Onnit Alpha Brain",
            "HVMN",
            "Thesis",
            "Qualia Mind",
            "Neurohacker Collective",
            "Double Wood"
          ]
        },
        {
          "key": "energy_metabolic",
          "rank": 6,
          "name": "Energy & metabolic support",
          "description": "Pre-workout formulas, caffeine-based and stimulant-free energy supplements, B-vitamin complexes, CoQ10, mitochondrial support stacks, and adaptogen-based energy blends. Largest segment by application in 2025 (energy & weight management combined).",
          "example_brands": [
            "Cellucor C4",
            "Ghost Pre-Workout",
            "Beam",
            "Ladder",
            "Four Sigmatic",
            "Thorne Energy"
          ]
        },
        {
          "key": "hormonal_endocrine",
          "rank": 7,
          "name": "Hormonal health & endocrine support",
          "description": "Supplements targeting testosterone, estrogen balance, cortisol, thyroid, and adrenal function. Includes men's hormone support (ashwagandha, tongkat ali, DHEA) and women's hormonal formulations (DIM, vitex, maca, phytoestrogens).",
          "example_brands": [
            "Momentous Ashwagandha",
            "Thorne Hormone Advantage",
            "Needed",
            "HUM Nutrition",
            "Nutrafol"
          ]
        },
        {
          "key": "joint_bone_connective",
          "rank": 8,
          "name": "Joint, bone & connective tissue health",
          "description": "Collagen peptides, glucosamine, chondroitin, MSM, hyaluronic acid, calcium, vitamin K2, and silicon-based compounds supporting joint integrity, bone density, and cartilage health.",
          "example_brands": [
            "Vital Proteins Collagen",
            "Ancient Nutrition",
            "Move Free",
            "Osteo Bi-Flex",
            "Thorne Joint"
          ]
        },
        {
          "key": "cardiovascular_heart",
          "rank": 9,
          "name": "Cardiovascular & heart health",
          "description": "Omega-3 fatty acids (fish oil, algae-based), CoQ10, magnesium, berberine, red yeast rice, nattokinase, and plant sterols supporting lipid profiles, blood pressure, and cardiac function.",
          "example_brands": [
            "Nordic Naturals",
            "OmegaQuant",
            "Thorne CoQ10",
            "Jarrow Formulas",
            "Life Extension"
          ]
        },
        {
          "key": "weight_metabolic_health",
          "rank": 10,
          "name": "Weight management & metabolic health",
          "description": "Appetite regulation, fat metabolism, blood sugar management, and GLP-1 support supplements. Includes fiber-based satiety aids, green tea extract, berberine, chromium, and emerging GLP-1 nutraceutical formulas.",
          "example_brands": [
            "Leanbiome",
            "Pendulum GLP-1 Probiotic",
            "Thorne Berberine",
            "NOW CLA",
            "Goli Nutrition"
          ]
        },
        {
          "key": "longevity_cellular",
          "rank": 11,
          "name": "Longevity & cellular health",
          "description": "Fastest-growing supplement segment (8.9% CAGR). NAD+ precursors (NMN, NR), resveratrol, fisetin, urolithin A, spermidine, senolytics, and other compounds targeting the hallmarks of aging at a cellular level.",
          "example_brands": [
            "Elysium Health",
            "Tru Niagen",
            "ProHealth NMN",
            "Timeline Mitopure",
            "Life Extension"
          ]
        },
        {
          "key": "womens_health",
          "rank": 12,
          "name": "Women's health",
          "description": "Life-stage-specific formulations for menstrual support, prenatal/postnatal nutrition, perimenopause, and menopause. Women represent ~36% of the US supplement market by consumer segment. Distinct from hormonal health subcategory in targeting specific female physiological transitions.",
          "example_brands": [
            "Ritual Essential for Women",
            "Needed Prenatal",
            "Thorne Basic Prenatal",
            "HUM Nutrition",
            "Garden of Life Women's"
          ]
        },
        {
          "key": "mens_health",
          "rank": 13,
          "name": "Men's health",
          "description": "Targeted formulations for testosterone support, prostate health, male fertility, and performance. Includes saw palmetto, lycopene, zinc, and sport-adjacent blends positioned specifically for male physiological needs.",
          "example_brands": [
            "Roman Testosterone",
            "Persona Men's",
            "NOW TestoJack",
            "Thorne Men's",
            "Beli Men's Prenatal"
          ]
        },
        {
          "key": "skin_hair_beauty",
          "rank": 14,
          "name": "Skin, hair & beauty supplements",
          "description": "Ingestible beauty supplements including collagen, biotin, ceramides, astaxanthin, hyaluronic acid, and antioxidant blends targeting skin elasticity, hair growth, and nail strength from within.",
          "example_brands": [
            "Nutrafol",
            "Viviscal",
            "HUM Beauty",
            "Moon Juice SuperHair",
            "Reserveage Collagen"
          ]
        },
        {
          "key": "stress_mood_mental",
          "rank": 15,
          "name": "Stress, mood & mental wellness",
          "description": "Adaptogen-based and neurotransmitter-support supplements for anxiety, stress resilience, and mood balance, including ashwagandha, rhodiola, L-theanine, magnesium, saffron, and 5-HTP. Distinct from nootropics, which focus on cognitive performance rather than emotional regulation.",
          "example_brands": [
            "Recess",
            "Moon Juice Magnesi-Om",
            "Onnit Shroom Tech",
            "KSM-66 Ashwagandha",
            "Calm by Nested Naturals"
          ]
        }
      ]
    },
    {
      "key": "wearables_tracking",
      "rank": 2,
      "name": "Wearables & Tracking",
      "subcategory_count": 10,
      "subcategories": [
        {
          "key": "smartwatches",
          "rank": 1,
          "name": "Smartwatches",
          "description": "Multi-sensor wrist devices tracking heart rate, SpO2, activity, sleep, and stress. Largest segment by revenue (~46% of US wearables market).",
          "example_brands": [
            "Apple Watch",
            "Samsung Galaxy Watch",
            "Garmin Forerunner",
            "Pixel Watch"
          ]
        },
        {
          "key": "fitness_activity_trackers",
          "rank": 2,
          "name": "Fitness & activity trackers",
          "description": "Dedicated bands and clips for steps, distance, HR, and calorie tracking. Lower price point than smartwatches; broad consumer reach.",
          "example_brands": [
            "Fitbit Charge",
            "Whoop 5.0",
            "Xiaomi Mi Band",
            "Amazfit Band"
          ]
        },
        {
          "key": "cgm",
          "rank": 3,
          "name": "Continuous glucose monitors (CGM)",
          "description": "Real-time blood glucose sensing via skin-adhered sensor. Fastest-growing wearables segment (~15% CAGR through 2031). Expanding beyond diabetes to wellness consumers.",
          "example_brands": [
            "Dexcom Stelo",
            "Abbott Freestyle Libre",
            "Levels CGM"
          ]
        },
        {
          "key": "smart_rings",
          "rank": 4,
          "name": "Smart rings",
          "description": "Discreet ring-form biometric monitors focused on HRV, sleep staging, recovery scoring, and readiness. Premium consumer segment.",
          "example_brands": [
            "Oura Ring 4",
            "Samsung Galaxy Ring",
            "RingConn",
            "Ultrahuman Ring"
          ]
        },
        {
          "key": "cardiac_ecg",
          "rank": 5,
          "name": "Cardiac & ECG monitors",
          "description": "Wearable devices with clinical-grade arrhythmia detection and ECG recording. Bridges consumer wellness and medical diagnostics.",
          "example_brands": [
            "AliveCor KardiaMobile",
            "Withings ScanWatch",
            "Apple Watch ECG"
          ]
        },
        {
          "key": "spo2_respiratory",
          "rank": 6,
          "name": "Blood oxygen (SpO2) & respiratory",
          "description": "Continuous pulse oximetry and breathing rate monitoring. Relevant for athletic performance, altitude, and sleep apnea screening.",
          "example_brands": [
            "Masimo MightySat",
            "Wellue O2Ring",
            "Garmin Pulse Ox"
          ]
        },
        {
          "key": "blood_pressure",
          "rank": 7,
          "name": "Blood pressure monitors",
          "description": "Wrist-worn or cuff-free smart BP devices enabling continuous or on-demand hypertension monitoring outside clinical settings.",
          "example_brands": [
            "Omron HeartGuide",
            "Sky Labs CART BP Ring",
            "Withings BPM Connect"
          ]
        },
        {
          "key": "biometric_patches",
          "rank": 8,
          "name": "Biometric patches & biosensors",
          "description": "Skin-adherent disposable or semi-disposable patches for continuous multi-parameter monitoring including temperature, hydration, and biomarkers.",
          "example_brands": [
            "Nuvectra",
            "VivaLNK",
            "Kenzen Patch",
            "Epicore Biosystems"
          ]
        },
        {
          "key": "smart_clothing",
          "rank": 9,
          "name": "Smart clothing & e-textiles",
          "description": "Garments with embedded sensors tracking muscle activity, respiration, posture, and biometrics during movement.",
          "example_brands": [
            "Hexoskin",
            "Athos Training System",
            "AiQ Smart Clothing"
          ]
        },
        {
          "key": "hearables",
          "rank": 10,
          "name": "Hearables & ear-worn devices",
          "description": "In-ear devices with health-sensing capabilities including body temperature, HR, and biofeedback beyond standard audio use.",
          "example_brands": [
            "Jabra Enhance",
            "Apple AirPods Pro (health features)",
            "Amazfit Earbuds"
          ]
        }
      ]
    },
    {
      "key": "diagnostics_testing",
      "rank": 3,
      "name": "Diagnostics & Testing",
      "subcategory_count": 10,
      "subcategories": [
        {
          "key": "blood_panel_metabolic",
          "rank": 1,
          "name": "Blood panel & metabolic testing",
          "description": "At-home or mail-in finger-prick blood tests measuring cholesterol, HbA1c, CBC, inflammation markers, and comprehensive metabolic panels. Largest DTC diagnostic segment.",
          "example_brands": [
            "Everlywell",
            "LetsGetChecked",
            "Quest Health",
            "Labcorp OnDemand"
          ]
        },
        {
          "key": "glucose_diabetes_monitoring",
          "rank": 2,
          "name": "Glucose & diabetes self-monitoring",
          "description": "Traditional at-home glucometers and test strips for blood glucose management. Dominant by unit volume; highest repeat-purchase rate.",
          "example_brands": [
            "Abbott FreeStyle",
            "Accu-Chek",
            "OneTouch",
            "Contour Next"
          ]
        },
        {
          "key": "genetic_dna",
          "rank": 3,
          "name": "Genetic & DNA testing kits",
          "description": "Saliva-based DTC kits providing polygenic risk scores, ancestry, trait analysis, and increasingly metabolic health insights.",
          "example_brands": [
            "23andMe",
            "AncestryDNA",
            "Viome Precision Intelligence",
            "Nebula Genomics"
          ]
        },
        {
          "key": "gut_microbiome_testing",
          "rank": 4,
          "name": "Gut microbiome testing",
          "description": "Stool-based analysis of gut bacterial composition, diversity, and metabolic function. Linked to nutrition, immunity, and mood.",
          "example_brands": [
            "Viome",
            "Zoe",
            "Ombre (Thryve)",
            "Biomesight",
            "Psomagen"
          ]
        },
        {
          "key": "hormone_fertility_testing",
          "rank": 5,
          "name": "Hormone & fertility testing",
          "description": "At-home panels measuring cortisol, thyroid (TSH/T3/T4), estrogen, testosterone, progesterone, and fertility markers (FSH, LH, AMH).",
          "example_brands": [
            "EverlyWell Hormone Tests",
            "Modern Fertility",
            "Mira Fertility",
            "LetsGetChecked"
          ]
        },
        {
          "key": "nutrient_deficiency_testing",
          "rank": 6,
          "name": "Nutrient deficiency testing",
          "description": "Blood or dried blood spot tests measuring vitamin D, B12, iron/ferritin, magnesium, omega-3 index, and related micronutrient levels.",
          "example_brands": [
            "OmegaQuant",
            "Thorne at-home tests",
            "Everlywell Vitamin D",
            "Inside Tracker"
          ]
        },
        {
          "key": "food_sensitivity_allergy",
          "rank": 7,
          "name": "Food sensitivity & allergy testing",
          "description": "IgG and IgE antibody-based panels identifying food intolerances and allergic sensitivities from blood spot samples.",
          "example_brands": [
            "Everlywell Food Sensitivity",
            "YorkTest",
            "Alletess",
            "Biotek Food Allergy"
          ]
        },
        {
          "key": "sti_infectious_disease",
          "rank": 8,
          "name": "STI & infectious disease testing",
          "description": "At-home swab, urine, or blood tests for HIV, herpes, chlamydia, gonorrhea, HPV, and other sexually transmitted or respiratory infections.",
          "example_brands": [
            "LetsGetChecked STI",
            "Everlywell STI",
            "Binax",
            "iHealth COVID"
          ]
        },
        {
          "key": "cancer_chronic_screening",
          "rank": 9,
          "name": "Cancer & chronic disease screening",
          "description": "Early-detection panels for colorectal, cervical, and other cancers, plus general chronic disease risk biomarkers.",
          "example_brands": [
            "Cologuard (Exact Sciences)",
            "Teal Health Teal Wand",
            "Grail Galleri",
            "Everlywell"
          ]
        },
        {
          "key": "heavy_metals_toxins",
          "rank": 10,
          "name": "Heavy metals & environmental toxins",
          "description": "Urine or blood-based screening for lead, mercury, arsenic, cadmium, and other environmental toxicant exposures.",
          "example_brands": [
            "Doctor's Data Heavy Metals",
            "Vibrant Wellness",
            "Mosaic Diagnostics"
          ]
        }
      ]
    },
    {
      "key": "sleep_optimization",
      "rank": 4,
      "name": "Sleep Optimization",
      "subcategory_count": 10,
      "subcategories": [
        {
          "key": "sleep_tracking_wearables",
          "rank": 1,
          "name": "Sleep tracking wearables",
          "description": "Rings, bands, and watches with dedicated sleep staging algorithms (light, deep, REM). Dominant segment at ~72% share of the sleep optimization market.",
          "example_brands": [
            "Oura Ring",
            "Whoop 5.0",
            "Apple Watch",
            "Fitbit Sense",
            "Garmin"
          ]
        },
        {
          "key": "smart_mattresses",
          "rank": 2,
          "name": "Smart mattresses & sleep systems",
          "description": "Technology-integrated mattresses and toppers with biometric sensors, automated temperature regulation, and personalized sleep coaching.",
          "example_brands": [
            "Eight Sleep Pod",
            "Sleep Number 360",
            "Bryte Balance Bed"
          ]
        },
        {
          "key": "sleep_apnea_cpap",
          "rank": 3,
          "name": "Sleep apnea & CPAP devices",
          "description": "Continuous positive airway pressure (CPAP), auto-CPAP (APAP), and mandibular advancement devices for sleep-disordered breathing. Largest clinical dollar volume in the category.",
          "example_brands": [
            "ResMed AirSense",
            "Philips DreamStation",
            "Inspire Medical",
            "Somryst"
          ]
        },
        {
          "key": "noncontact_sleep_monitors",
          "rank": 4,
          "name": "Non-contact & bedside sleep monitors",
          "description": "Radar, sonar, or under-mattress sensor devices that monitor sleep without body contact, tracking breathing, movement, and stages.",
          "example_brands": [
            "Withings Sleep Analyzer",
            "Google Nest Hub (Sleep Sensing)",
            "Emfit QS"
          ]
        },
        {
          "key": "sleep_environment",
          "rank": 5,
          "name": "Sleep environment optimization",
          "description": "Smart lighting, blackout solutions, thermostat controls, and circadian-support devices that optimize the sleep environment.",
          "example_brands": [
            "Hatch Restore",
            "Casper Glow",
            "Philips Hue Sleep Mode",
            "Eight Sleep Climate"
          ]
        },
        {
          "key": "white_noise_sound",
          "rank": 6,
          "name": "White noise & sound therapy",
          "description": "Dedicated sound machines, apps, and audio devices delivering white noise, pink noise, brown noise, or sleep-specific audio to mask disruption.",
          "example_brands": [
            "LectroFan",
            "Hatch Rest",
            "Calm App",
            "Bose Sleepbuds",
            "Sleep Shepherd"
          ]
        },
        {
          "key": "sleep_supplements_nutraceuticals",
          "rank": 7,
          "name": "Sleep supplements & nutraceuticals",
          "description": "Melatonin, magnesium glycinate, L-theanine, ashwagandha, GABA, and other evidence-based compounds formulated to support sleep onset and quality. Classified here, not under Supplements main category.",
          "example_brands": [
            "Natrol Melatonin",
            "Olly Sleep",
            "Moon Juice Magnesi-Om",
            "Beam Dream"
          ]
        },
        {
          "key": "neurostim_sleep_headbands",
          "rank": 8,
          "name": "Neurostimulation & sleep headbands",
          "description": "EEG-based or tDCS wearable devices targeting brainwave modulation to enhance slow-wave or deep sleep.",
          "example_brands": [
            "Dreem 2 Headband",
            "Neurosity",
            "Muse S",
            "SleepSmart",
            "Philips SmartSleep"
          ]
        },
        {
          "key": "cbti_digital_therapy",
          "rank": 9,
          "name": "CBT-I & digital sleep therapy apps",
          "description": "AI-guided Cognitive Behavioral Therapy for Insomnia (CBT-I) programs, sleep coaching platforms, and digital therapeutics for chronic sleep issues.",
          "example_brands": [
            "Sleepio",
            "Somryst (FDA-cleared)",
            "Somnia",
            "Headspace Sleep",
            "Calm"
          ]
        },
        {
          "key": "sleep_pillows_positional",
          "rank": 10,
          "name": "Sleep pillows & positional aids",
          "description": "Ergonomic and smart pillows, sleep position trainers, wedges, and anti-snore devices that use physical positioning to improve sleep quality.",
          "example_brands": [
            "Purple Harmony Pillow",
            "Eight Sleep Pillow",
            "Rematee Anti-Snore",
            "Zzoma"
          ]
        }
      ]
    },
    {
      "key": "recovery_regeneration",
      "rank": 5,
      "name": "Recovery & Regeneration",
      "subcategory_count": 10,
      "subcategories": [
        {
          "key": "percussion_vibration",
          "rank": 1,
          "name": "Percussion & vibration therapy",
          "description": "Handheld massage guns and vibration devices delivering targeted percussive therapy for muscle recovery, soreness reduction, and tissue mobilization. Most widely adopted at-home recovery modality.",
          "example_brands": [
            "Theragun",
            "Hypervolt",
            "TimTam",
            "Ekrin Athletics",
            "Renpho"
          ]
        },
        {
          "key": "compression_therapy",
          "rank": 2,
          "name": "Compression therapy",
          "description": "Pneumatic compression boots, sleeves, and full-leg garments that use sequential air pressure to accelerate lymphatic drainage and muscle recovery.",
          "example_brands": [
            "NormaTec (Hyperice)",
            "RecoveryPump",
            "Air Relax",
            "Speed Hound"
          ]
        },
        {
          "key": "cold_therapy",
          "rank": 3,
          "name": "Cold therapy & cryotherapy",
          "description": "Ice baths, cold plunge tubs, portable cold devices, and whole-body cryotherapy chambers for inflammation reduction and recovery acceleration.",
          "example_brands": [
            "Plunge Pro",
            "Ice Barrel",
            "Morozko Forge",
            "iCRYO",
            "NOVAA Cold Therapy"
          ]
        },
        {
          "key": "red_light_photobiomodulation",
          "rank": 4,
          "name": "Red light & photobiomodulation",
          "description": "LED panels, pads, and targeted devices emitting red (630-700nm) and near-infrared (800-1100nm) light for cellular energy, muscle recovery, and tissue repair.",
          "example_brands": [
            "Joovv",
            "Red Light Rising",
            "Mito Red Light",
            "Platinum LED",
            "TheraLight"
          ]
        },
        {
          "key": "sauna_heat_therapy",
          "rank": 5,
          "name": "Sauna & heat therapy",
          "description": "Infrared saunas, sauna blankets, and traditional heat therapy devices supporting cardiovascular adaptation, detoxification, and recovery.",
          "example_brands": [
            "Sunlighten",
            "HigherDOSE Sauna Blanket",
            "Clearlight Sauna"
          ]
        },
        {
          "key": "ems_tens",
          "rank": 6,
          "name": "Electrical muscle stimulation (EMS/TENS)",
          "description": "Neuromuscular electrical stimulation devices for active recovery, pain relief, and muscle activation in rehabilitation and performance contexts.",
          "example_brands": [
            "Compex",
            "Powerdot",
            "Marc Pro",
            "iReliev",
            "Therabody PowerDot"
          ]
        },
        {
          "key": "hbot",
          "rank": 7,
          "name": "Hyperbaric oxygen therapy (HBOT)",
          "description": "Personal and clinical pressurized chambers delivering elevated oxygen concentrations to accelerate tissue repair and systemic recovery.",
          "example_brands": [
            "Henshaw Monozen",
            "Summit to Sea Dive",
            "OxyHealth Vitaeris",
            "mild HBOT"
          ]
        },
        {
          "key": "stretch_mobility",
          "rank": 8,
          "name": "Stretch & mobility tools",
          "description": "Foam rollers, fascia massage tools, assisted stretching systems, and manual mobility equipment for range-of-motion improvement and tissue quality.",
          "example_brands": [
            "Rogue Foam Roller",
            "Rollga",
            "TriggerPoint Grid",
            "StretchLab",
            "HyperVolt Foam"
          ]
        },
        {
          "key": "hrv_recovery_apps",
          "rank": 9,
          "name": "HRV & recovery tracking apps",
          "description": "Software platforms providing readiness scores, HRV trending, strain/load monitoring, and training adaptation analytics.",
          "example_brands": [
            "WHOOP app",
            "Garmin Body Battery",
            "Elite HRV",
            "HRV4Training",
            "Athlytic"
          ]
        },
        {
          "key": "contrast_therapy",
          "rank": 10,
          "name": "Contrast therapy systems",
          "description": "Products and protocols combining alternating hot/cold exposure (ice bath + sauna) shown to enhance recovery beyond either modality alone.",
          "example_brands": [
            "Plunge + Sauna bundles",
            "LUMI contrast therapy",
            "Polar Monteith systems"
          ]
        }
      ]
    }
  ],
  "additional_notes": [
    "Multi-classification is permitted: a product MAY carry more than one subcategory key when its primary use case genuinely spans subcategories (per User Flow PDF page 6 supporting note). The classifier should default to a single best subcategory and only multi-classify when warranted."
  ]
};
